import PropTypes from 'prop-types';

import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const BanUserButton = ({ onClick }) => {
  const theme = useTheme();

  return (
    <Button
      disableElevation
      onClick={onClick}
      sx={{
        marginLeft: '-1rem',
      }}
    >
      <Box display="flex" gap="1rem">
        <BlockOutlinedIcon color="secondary" />
        <Typography color={theme.palette.text.primary}>Ban A Member</Typography>
      </Box>
    </Button>
  );
};

BanUserButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default BanUserButton;
